// "You don't have access to this document yet": what an editor shows for a
// 403/404 instead of the raw error. Access is often on its way (a share being
// granted), so it offers to check again.

import { useTranslation } from 'react-i18next';
import { Lock, RefreshCw } from 'lucide-react';

export function EditorNoAccess({ onRetry }) {
  const { t } = useTranslation('editor');
  return (
    <div className="flex h-full flex-1 flex-col items-center justify-center gap-3 p-6 text-center" data-testid="editor-no-access">
      <span className="flex h-10 w-10 items-center justify-center rounded-full bg-muted">
        <Lock className="h-5 w-5 text-muted-foreground" />
      </span>
      <p className="text-sm font-semibold text-foreground">{t('noAccess.title')}</p>
      <p className="max-w-sm text-xs text-muted-foreground">{t('noAccess.hint')}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="inline-flex items-center gap-1.5 rounded-md border border-border px-3 py-1.5 text-xs font-medium hover:bg-muted cursor-pointer"
        >
          <RefreshCw className="h-3.5 w-3.5" /> {t('noAccess.retry')}
        </button>
      )}
    </div>
  );
}
